(function () {
  'use strict';
  const supported = (country, currency) => ({NZ:'NZD', AU:'AUD'})[country] === currency;
  const price = value => Number.isSafeInteger(value) && value > 0;
  function currencyMatches(rendered, runtime, cart, requireCart = false) {
    return ['NZD', 'AUD'].includes(rendered) && (!runtime || runtime === rendered) && (!cart || cart === rendered) && (!requireCart || cart === rendered);
  }
  function sameContext(expected, actual) {
    return !!expected && !!actual && supported(expected.country, expected.currency) && expected.country === actual.country && expected.currency === actual.currency && String(expected.themeId) === String(actual.themeId);
  }
  function create(context, io) {
    let generation = 0, invalidated = false;
    const fail = () => new Error('Your market or price needs to be refreshed. Reload this page before ordering; your currency has not been changed.');
    const isCurrent = config => !invalidated && sameContext(context, {...context, ...config}) && currencyMatches(context.currency, io.runtimeCurrency());
    const invalidate = () => { generation++; invalidated = true; };
    async function read() {
      if (!isCurrent(context)) throw fail();
      const started = generation;
      const url = new URL(io.root() + 'collections/bamboo-boards', io.href());
      url.searchParams.set('section_id', 'aroha-market-context');
      const response = await io.fetch(url.href, {credentials:'same-origin', cache:'no-store', redirect:'error', headers:{Accept:'text/html'}});
      if (!response.ok) throw fail();
      const data = io.parse(await response.text());
      if (started !== generation || !isCurrent(context) || !sameContext(context, data)) throw fail();
      return data;
    }
    function variant(data, handle, productId, variantId, expectedPrice) {
      if (!isCurrent(context) || !sameContext(context, data)) throw fail();
      const product = data.products?.[handle];
      const matches = (product?.variants || []).filter(v => String(v.id) === String(variantId));
      if (String(product?.id) !== String(productId) || product.handle !== handle || matches.length !== 1 || !price(matches[0].price) || (expectedPrice !== undefined && matches[0].price !== expectedPrice)) throw fail();
      return matches[0];
    }
    return {context, isCurrent, invalidate, read, variant};
  }
  const api = {supported, price, currencyMatches, sameContext, create};
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (typeof document === 'undefined') return;
  const source = document.getElementById('ArohaMarketContext');
  if (!source) return;
  const context = JSON.parse(source.textContent);
  const market = create(context, {
    runtimeCurrency: () => window.Shopify?.currency?.active,
    root: () => (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/'),
    href: () => window.location.href,
    fetch: (...args) => window.fetch(...args),
    parse: html => JSON.parse(new DOMParser().parseFromString(html, 'text/html').querySelector('[data-aa-market-context]').textContent)
  });
  window.ArohaMarket = {...api, ...market};
  document.addEventListener('submit', event => { if (event.target?.action && new URL(event.target.action).pathname.endsWith('/localization')) market.invalidate(); }, true);
  window.addEventListener('pageshow', event => { if (event.persisted) market.invalidate(); });
})();
